import { useTransition, config, SpringConfig } from '@react-spring/web'
import { useLocation, Routes } from 'react-router-dom'

import { AnimationWrapper, TransitionWrapper, getFadeAnimation, getSlideAnimation } from './styles'

type Props = {
  children: React.ReactNode
  direction?: 'forward' | 'backward'
  springConfig?: SpringConfig
  animationEffect?: 'slide' | 'fade'
}

export const RouteTransitionSwitch = (props: Props) => {
  const {
    children,
    direction = 'forward',
    animationEffect = 'slide',
    springConfig = config.default,
  } = props
  const location = useLocation()
  const transition = useTransition(location, {
    config: springConfig,
    ...(animationEffect === 'slide' ? getSlideAnimation(direction) : getFadeAnimation()),
  })

  return (
    <TransitionWrapper>
      {transition((style, item) => (
        <AnimationWrapper style={style}>
          <Routes location={item}>{children}</Routes>
        </AnimationWrapper>
      ))}
    </TransitionWrapper>
  )
}
